import React from "react";

import { Stack } from "@mui/material";

import { Button } from "./styles";

interface UpdateButtonsProps {
  cancelLabel?: string;
  disabled?: boolean;
  loading?: boolean;
  onCancel: (event: React.MouseEvent) => void;
  onSubmit: (event: React.MouseEvent) => void;
  saveLabel?: string;
}

const UpdateButtons = ({
  cancelLabel = "Cancel",
  disabled = false,
  loading = false,
  onCancel,
  onSubmit,
  saveLabel = "Save Changes",
}: UpdateButtonsProps) => {
  return (
    <Stack
      direction={{ xxs: "column", sm: "row" }}
      alignItems="center"
      spacing={1}
    >
      <Button
        type="submit"
        onClick={onSubmit}
        primary
        sx={{ mr: { xxs: 0, sm: 1 }, width: { xxs: "100%", sm: "auto" } }}
        loading={loading}
        disabled={disabled}
      >
        {saveLabel}
      </Button>
      <Button
        onClick={onCancel}
        disabled={disabled}
        sx={{ width: { xxs: "100%", sm: "auto" } }}
      >
        {cancelLabel}
      </Button>
    </Stack>
  );
};

export default UpdateButtons;
